import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ContentWrapper, Panel } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import SAMLTabsContainer from './samlTabs';
import PortalToastrContainer from '../portal/portalToastrContainer';
import styles from './style.scss';

@inject('translationsStore', 'routesStore') @observer
export default class SAMLContainer extends Component {

    t = this.props.translationsStore.translate;
    routesStore = this.props.routesStore;
    
    componentDidMount() {

        this.routesStore.setSettingsSelectedTabId(this.props.tabId);
    }

    render() {

        return(
            <ContentWrapper className='content-wrapper'>
                <Panel className={classNames('content-left-hand', styles.contentLeftHandSetting)}>
                    <div className='setting-title' data-cy='saml-screen'>
                        {this.t('SAML_SETTINGS')}
                    </div>
                    <div className='setting-sub-title'>
                        {this.t('SAML_SETTINGS_DESCRIPTIONS')}
                    </div>
                </Panel>
                <Panel
                    className='content-right-hand'
                >
                    <SAMLTabsContainer />
                </Panel>
            </ContentWrapper>
        );
    }
}